<template>
    <div class="col-sm-12 pl-3 pr-3">
        <div v-if="results && results.length > 0" class="col-sm-12" :class="{'list-content' : !hideBorders}">
            <vue3-datatable
                :rows="results"
                :columns="fields"
                :pagination="false"
                :sticky-header="true"
                :height="results.length > 7 ? '60vh' : '100%'"
                :sortable="true"
                skin="bh-table-compact"
                row-class="routa-table-row"
                cell-class="routa-table-cell"
                @row-click="emitEdit"
            >
                <template #empty>
                    <div class="text-center my-2">
                        {{ $t('common.no_results') }}
                    </div>
                </template>
                <template #reporting_date="data">
                    {{ data.value.reporting_date ? getShortDateString(data.value.reporting_date) : '' }}
                </template>
            </vue3-datatable>
        </div>
    </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {deliveryNoteHelper} from "@/components/mixins/DeliveryNoteMixin";
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: "MaterialReportList",
    mixins: [timeUtils, deliveryNoteHelper],
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        },
        isObserver: {
            type: Boolean,
            default: false
        },
        hideBorders: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        fields() {
            return [
                {
                    field: "reporting_date",
                    title: this.$t('daily_summary.date'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "reporter_name",
                    title: this.$t('material_reports.reporter'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'company',
                    title: this.$t('common.company'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "customer_name",
                    title: this.$t('contracts.customer'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "contract_name",
                    title: this.$t('orders.contract'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "order_name",
                    title: this.$t('orders.order'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "material",
                    title: this.$t('material_reports.material'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "amount",
                    title: this.$t('material_reports.amount'),
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                },
                {
                    field: "unit",
                    title: this.$t('material_reports.unit'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "info",
                    title: this.$t('material_reports.info'),
                    sort: true,
                    headerClass: 'routa-table-header'
                }
            ]
        }
    },
    methods: {
        emitEdit: function (report) {
            if (this.isObserver) {
                let item = this.results.find(item => parseInt(item.id) === parseInt(report.id))
                if (item) {
                    this.$emit('editReport', item)
                }
            }
        },
    }
}
</script>
<style scoped lang="scss">
.transport {
    color: #ffffff;
    background: #1F7F35;
    padding: .2em;
}

.unloading {
    color: #ffffff;
    background: #1E88E5;
    padding: .2em;
}

</style>
